import { render, staticRenderFns } from "./WysiwygEditorDialog.vue?vue&type=template&id=623ee963&"
import script from "./WysiwygEditorDialog.vue?vue&type=script&lang=js&"
export * from "./WysiwygEditorDialog.vue?vue&type=script&lang=js&"
import style0 from "./WysiwygEditorDialog.vue?vue&type=style&index=0&id=623ee963&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports